import { bimRoomsAPI } from "@/views/BimRooms/services/api";
import { getAllRooms } from "@/views/BuildingSettings/services";

export const getBimRooms = async () => {
  try {
    const res = await bimRoomsAPI.getList();
    return res?.data;
  } catch (e) {}
};

export const saveBimRoom = async (data) => {
  try {
    return await bimRoomsAPI.save(data);
  } catch (e) {
    throw e;
  }
};

export const importBimRoomsExcel = async (formData) => {
  try {
    return await bimRoomsAPI.importExcel(formData);
  } catch (e) {
    throw e;
  }
};

export { getAllRooms };
